import React from 'react';
import styles from './ConfirmDialog.module.css';

interface ConfirmDialogProps {
  titulo: string;
  mensagem: string;
  rotuloConfirmar?: string;
  rotuloCancelar?: string;
  variante?: 'perigo' | 'padrao';
  carregando?: boolean;
  onConfirmar: () => void;
  onCancelar: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  titulo,
  mensagem,
  rotuloConfirmar = 'Confirmar',
  rotuloCancelar = 'Cancelar',
  variante = 'padrao',
  carregando = false,
  onConfirmar,
  onCancelar,
}) => {
  return (
    <div className={styles.overlay} role="presentation" onClick={onCancelar}>
      <div
        className={styles.dialog}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="confirm-dialog-title" className={styles.titulo}>
          {titulo}
        </h2>
        <p className={styles.mensagem}>{mensagem}</p>
        <div className={styles.acoes}>
          <button type="button" className={styles.botaoCancelar} onClick={onCancelar} disabled={carregando}>
            {rotuloCancelar}
          </button>
          <button
            type="button"
            className={variante === 'perigo' ? styles.botaoPerigo : styles.botaoConfirmar}
            onClick={onConfirmar}
            disabled={carregando}
          >
            {carregando ? 'Processando…' : rotuloConfirmar}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;